import { createSystem, defaultConfig, defineConfig } from '@chakra-ui/react'
import { acpTokens } from './tokens'
import { buttonRecipe, badgeRecipe } from './recipes'
import { acpGlobalStyles } from './globalStyles'

const customConfig = defineConfig({
  theme: {
    tokens: {
      colors: acpTokens.colors,
      fonts: acpTokens.fonts,
      radii: acpTokens.radii,
    },
    recipes: {
      button: buttonRecipe,
      badge: badgeRecipe,
    },
    // ── Standardized heading styles (single source of truth) ──────────
    // Large page/section titles route through `textStyle="pageTitle"` instead
    // of repeating fontFamily/fontWeight/color inline. Tune weight/color/tracking
    // HERE once — every big title updates. fontSize stays per-instance.
    textStyles: {
      pageTitle: {
        description: 'Page-level title (H1) — Space Grotesk, medium weight, soft ink. Size lives HERE, not per-instance.',
        value: {
          fontFamily: 'heading',
          fontWeight: '500',
          color: '#262b38',
          letterSpacing: '0',
          fontSize: { base: '1.35rem', md: '1.8rem' },
          lineHeight: '1.15',
        },
      },
    },
  },
  globalCss: acpGlobalStyles,
})

export const system = createSystem(defaultConfig, customConfig, {
  cssVarsRoot: ':where(html)',
})

export { acpTokens, UI_TOKENS } from './tokens'
export type { AcpColor, UIBorderToken, UIBackgroundToken, UITextToken } from './tokens'
export { buttonRecipe, badgeRecipe } from './recipes'
export { acpGlobalStyles } from './globalStyles'
export {
  ACP_COLORS,
  ACP_RADII,
  ACP_VARIANTS,
  ACP_SEMANTIC_TOKENS,
  ACP_TRANSITIONS,
  ACP_SHADOWS,
} from './constants'
export type {
  ButtonVariant,
  BadgeVariant,
  CardVariant,
  InputVariant,
  SpinnerVariant,
} from './constants'
